<div>
  <h4 mat-dialog-title><ng-container *ngIf="!isEdit">Add</ng-container><ng-container *ngIf="isEdit">Edit</ng-container>Horizontal Price Line</h4>
  <div class="row">
    <div class="col-md-6">Select Color</div>
    <div class="col-md-4">
      <input
        style="padding: 0"
        type="color"
        [value]="color"
        (change)="colorUpdate($event)"
      />
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">Signal Line</div>
    <div class="col-md-4">
      <mat-checkbox [(ngModel)]="isSignal">
          Yes
        </mat-checkbox>

    </div>
  </div>
  <div>
  <div>
    <div class="pt-3">
      <button mat-button (click)="onDismiss()">No</button>
      <button mat-raised-button [color]="'glb_greenbtn'" (click)="onConfirm()">
        OK
      </button>
    </div>
  </div>
</div>
